export default __webpack_public_path__ + "static/media/file-plus.172608c6.svg";